// extracted by mini-css-extract-plugin
export default {"info-box":"FooterNavbar_info-box__ysjj8","links":"FooterNavbar_links__ne-jm","footerTitleFontSize":"FooterNavbar_footerTitleFontSize__gCi0I"};